import multiGuard from '@/router/utils/vue-router-multiguard'
import fetchSubscriptionGuard from '@/router/guards/fetch-subscription-guard'
import isExpiredGuard from '@/router/guards/is-expired-guard'
import USER_TYPES from '@/constants/authorization/user-types'
import checkTokenGuard from '@/router/guards/check-token-guard'
import authGuard from '@/router/guards/auth-guard'
import checkExpirationGuard from '@/router/guards/check-expiration-guard'
import checkRouteQueryGuard from '@/router/guards/check-route-query-guard'
import marketingGuard from '@/router/guards/marketing-guard'
import renewGuard from '@/router/guards/renew-guard'

const billingRoutes = [
  {
    path: '/billing',
    component: { render: (h: any) => h('router-view') },
    beforeEnter: multiGuard([checkTokenGuard, authGuard, fetchSubscriptionGuard, checkExpirationGuard, checkRouteQueryGuard, marketingGuard]),
    children: [
      {
        path: 'expired',
        name: 'billing:expired',
        beforeEnter: isExpiredGuard,
        component: () => import(/* webpackChunkName: "billing" */ '@/views/admin/billing/ExpiredView.vue'),
      },
      {
        path: 'history',
        name: 'billing:billing-history',
        meta: { userTypes: [USER_TYPES.OWNER] },
        component: () => import(/* webpackChunkName: "billing" */ '@/views/admin/billing/billing-history/InvoicesTable.vue'),
      },
      {
        path: 'invoice/:id',
        name: 'billing:invoice',
        beforeEnter: renewGuard,
        meta: { userTypes: [USER_TYPES.OWNER] },
        component: () => import(/* webpackChunkName: "billing" */ '@/views/admin/billing/InvoiceView.vue'),
      },
      {
        path: 'info',
        name: 'billing:billing-information',
        meta: { userTypes: [USER_TYPES.OWNER] },
        component: () => import(/* webpackChunkName: "billing" */ '@/views/admin/billing/BillingInformationView.vue'),
      },
      {
        path: 'subscription',
        name: 'billing:manage-subscription',
        meta: { userTypes: [USER_TYPES.OWNER] },
        component: () => import(/* webpackChunkName: "billing" */ '@/views/admin/billing/ManageSubscription.vue'),
      },
      {
        path: 'plans',
        name: 'billing:plans',
        alias: '/admin/pricing',
        meta: { userTypes: [USER_TYPES.OWNER] },
        beforeEnter: checkRouteQueryGuard,
        component: () => import(/* webpackChunkName: "billing" */ '@/views/admin/billing/PlansView.vue'),
      },
    ],
  },
  {
    path: '/invoice',
    component: () => import(/* webpackChunkName: "billing" */ '@/layouts/full/OkLayoutFull.vue'),
    children: [
      {
        path: ':uuid',
        name: 'public-invoice',
        meta: {
          layout: 'full',
          layoutClass: 'public-invoice-layout',
        },
        component: () => import(/* webpackChunkName: "billing" */ '@/views/admin/billing/PublicInvoice.vue'),
      },
    ],
  },
]

export default billingRoutes
